<template>
  <!-- Schedule Delivery -->
  <v-container>
    <Heading msg="Schedule Delivery" />
    <v-row class="text-center">
      <v-col class="mb-1">
        <v-snackbar
          transition="slide-y-transition"
          v-model="alert"
          top
          timeout="10000"
          color="sokoDeep"
          dark
          >{{ alertMsg }}</v-snackbar
        >
        <router-link
          v-if="alertType === 'success'"
          to="/summary"
          class="sokoPrimary--text mt-5"
          style="text-decoration: none"
          >See Summary<v-icon right>mdi-arrow-right</v-icon></router-link
        >
      </v-col>
    </v-row>
    <template>
      <OrderForm v-on:orderAlert="showAlert" />
    </template>

    <v-overlay :value="redirecting">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import OrderForm from "@/components/Forms/Order.vue";
import Heading from "@/components/Layout/Heading.vue";

export default {
  name: "Delivery",

  components: {
    OrderForm,
    Heading,
  },

  props: {
    userDetails: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    alertType: "error",
    alertMsg: "Error!",
    alert: false,
    redirecting: false,
  }),

  methods: {
    showAlert(event) {
      if (event.type === "success") {
        // if (this.userDetails.fname === msg.sendername)
        this.alertType = "error";
        this.alertMsg = `Your delivery to ${event.msg.recepientname} has been successfully scheduled. You will be redirected to the payment page.`;
        this.alert = true;
        window.scrollTo(0, 0);
        this.redirecting = true;
        return;
      } else if (event.type === "connError")
        this.alertMsg =
          "No connection was established to schedule your delivery. Please check you internet connection and try again later!";
      else
        this.alertMsg =
          "Oops! Something unexpected happened while trying to schedule your delivery. Please try again later.";
      this.alertType = "error";
      this.alert = true;
      // window.scrollTo(0, 0);
    },
  },
};
</script>

<style></style>
